import {Model, ModelMixin} from '../../common/model.class';

/**
 * Created by Rodrigo Quesada on 28/02/17.
 */
export class PlaceInfo extends ModelMixin() implements Model<PlaceInfo> {

    TYPE = PlaceInfo;

    public name: string;
    public address1: string;
    public address2: string;
    public postalCode: string;
    public city: string;
    public stateOrProvince: string;
    public country: string;
    public phone: string;
    public fax: string;

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/info/place/place-info.model.ts